import { SimpleGrid, Stack, Text } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'

import Resource from '@/features/resources/components/Resource'
import { ResourceListItem } from '@/features/resources/types'

import { checkNotEmpty } from '@/lib/utils'

const SECTION_HEADER_STYLE = {
  fontSize: {
    base: '3.5xl',
    sm: '4xl',
  },
  fontWeight: 'bold',
  textAlign: {
    base: 'center',
    sm: 'left',
  },
}

interface Props {
  ebooks?: ResourceListItem[]
  tools?: ResourceListItem[]
  datasheets?: ResourceListItem[]
}

function ResourceList({
  ebooks = [],
  tools = [],
  datasheets = [],
}: Props): React.ReactElement {
  const { t } = useTranslation('resource')

  return (
    <Stack spacing={{ base: '12', sm: '24' }} layerStyle="container">
      {checkNotEmpty(ebooks) && (
        <Stack spacing="8">
          <Text sx={SECTION_HEADER_STYLE}>{t('list.ebooks')}</Text>
          <SimpleGrid
            templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
            gap={{ base: 10, md: 7 }}
          >
            {ebooks.map((datum, index) => (
              <Resource key={`${index}`} {...datum} />
            ))}
          </SimpleGrid>
        </Stack>
      )}
      {checkNotEmpty(tools) && (
        <Stack spacing="8">
          <Text sx={SECTION_HEADER_STYLE}>{t('list.tools')}</Text>
          <SimpleGrid
            templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
            gap={{ base: 10, md: 7 }}
          >
            {tools.map((datum, index) => (
              <Resource key={`${index}`} {...datum} />
            ))}
          </SimpleGrid>
        </Stack>
      )}
      {checkNotEmpty(datasheets) && (
        <Stack spacing="8">
          <Text sx={SECTION_HEADER_STYLE}>{t('list.datasheets')}</Text>
          <SimpleGrid
            templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
            gap={{ base: 10, md: 7 }}
          >
            {datasheets.map((datum, index) => (
              <Resource key={`${index}`} {...datum} />
            ))}
          </SimpleGrid>
        </Stack>
      )}
    </Stack>
  )
}

export default ResourceList
